/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Related_Group_Not_FoundInputs */



/**
* | output |
* | --- |
* | "Could not find the related event group" |
*
* @param {Manual_Qc_Related_Group_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_related_group_not_found = /** @type {((inputs?: Manual_Qc_Related_Group_Not_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Related_Group_Not_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de trouver le groupe d'evenements associe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die zugehörige Ereignisgruppe konnte nicht gefunden werden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile trovare il gruppo di eventi correlato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось найти связанную группу событий.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo encontrar el grupo de eventos relacionado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("找不到相关的事件组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("関連するイベントグループが見つかりませんでした")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संबंधित इवेंट समूह नहीं मिल सका")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não foi possível encontrar o grupo de eventos relacionado.")
	return /** @type {LocalizedString} */ ("Could not find the related event group")
});